<div class="ag-overlay-loading-center" >

  <mat-icon>hourglass_empty</mat-icon>

  <span> {{ params.loadingMessage }} </span>

</div>
